/**
 * A message that can be sent by the messaging service.
 */
export class Message<T> {
    /**
     * Gets the kind of the message.
     */
    public get kind(): MessageKind {
        return this._kind;
    }

    /**
     * Gets the message body.
     */
    public get payload(): T {
        return this._payload;
    }

    /**
     * Initializes a new instance of the Message class.
     * @param _kind The message kind.
     * @param _payload The message body.
     */
    constructor(private _kind: MessageKind, private _payload: T) {
    }
}

/**
 * Enumerates message kinds.
 */
export enum MessageKind {
    /**
     * A message containing validation error details.
     */
    ValidationError,

    /**
     * A message containing an entity's field.
     */
    Field,

    /**
     * A message containing an index.
     */
    Index,

    /**
     * A message containing an entity.
     */
    Entity,

    /**
     * An empty message.
     */
    Empty,

    /**
     * Branch not found.
     */
    BranchNotFound,

    /**
     * GitHub failure.
     */
    GitHubFailure,

    /**
     * IR updated.
     */
    IRUpdatedInLinkedservice,

    /**
     * PE created.
     */
    PECreated,

    /**
     * Monaco action
     */
    Monaco
}
